import { render, staticRenderFns } from "./QuotationBlockCard.vue?vue&type=template&id=fc8f347c&scoped=true"
import script from "./QuotationBlockCard.vue?vue&type=script&lang=ts"
export * from "./QuotationBlockCard.vue?vue&type=script&lang=ts"
import style0 from "./QuotationBlockCard.vue?vue&type=style&index=0&id=fc8f347c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8f347c",
  null
  
)

export default component.exports